export type ReservationStatus =
  | 'active'
  | 'canceled'
  | 'finished'
  | 'noShow'
  | 'autoResolved'
  | 'pendingPayment'
  | 'rebooked'
  | 'resold';

export const INACTIVE_RESERVATION_STATUSES: ReservationStatus[] = [
  'autoResolved',
  'canceled',
  'finished',
  'noShow',
  'rebooked',
  'resold',
];

export interface CancellationPolicy {
  fee: number;
  hoursBeforeReservation: number;
  id: string;
  threshold: number;
}

export interface TransactionLineItems {
  id: string;
  name: string;
  pricePerUnit: number;
  quantity: number;
}

export interface TransactionDetails {
  createdBy: { fullName?: string };
  fee: number;
  price: number;
  receiptNumber: string;
  refundAmount: number | null;
  tax: number;
  total: number;
  lineItems?: TransactionLineItems[];
  purchaseDiscount?: {
    code: string | null;
    percentage: number;
    amount: number;
  } | null;
}

export interface LightspeedOrderItem {
  id: string;
  name: string;
  quantity: number;
  pricePerUnit: number;
  total: number;
  accountingGroupName: string | null;
}

export interface LightspeedOrder {
  status: 'open' | 'closed' | 'cancelled';
  currency: string;
  items: LightspeedOrderItem[];
  subtotal: number;
  tax: number;
  total: number;
  paid: number;
  updatedAt: string;
}

export interface ReservationGuest {
  email?: string;
  firstName: string;
  id: string;
  isDeleted: boolean;
  lastName: string;
  phone?: string;
  isRegistered?: boolean;
}
